import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { SLINKY } from 'HubStyleTokens/colors';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FOLDER_TAB_WIDTH = 120;
export const StyledFolderTabContent = styled.div.withConfig({
  displayName: "ViewFoldersTab__StyledFolderTabContent",
  componentId: "sc-17aojax-0"
})(({
  $active,
  theme
}) => `
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${theme.space['200']};

  background-color: ${$active ? theme.color['fill-surface-default'] : theme.color['fill-tertiary-hover']};
  border-bottom: ${theme.borderWidth['100']} solid${$active ? `transparent` : theme.color['border-tertiary-default']};
  border-left: calc(1px / 2) solid ${theme.color['border-tertiary-default']};
  border-right: calc(1px / 2) solid ${theme.color['border-tertiary-default']};
  border-top: ${theme.borderWidth['100']} solid ${theme.color['border-tertiary-default']};
  cursor: pointer;
  height: 39px;
  padding: 0 ${theme.space['400']};
  position: relative;
  top: 1px;
`);
export function ViewFoldersTabV2({
  isFoldersMode,
  onTabClick
}) {
  return /*#__PURE__*/_jsx(Box, {
    grow: 0,
    shrink: 1,
    basis: "auto",
    marginInlineStart: "1100",
    minInlineSize: `${FOLDER_TAB_WIDTH}px`,
    inlineSize: `${FOLDER_TAB_WIDTH}px`,
    children: /*#__PURE__*/_jsxs(StyledFolderTabContent, {
      $active: isFoldersMode,
      "data-tab-pinned": "true",
      "data-test-id": "crm-listing-folder-tab",
      "data-view-id": "folders",
      onClick: onTabClick,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        color: SLINKY,
        name: isFoldersMode ? 'folderOpen' : 'folder',
        size: "xxs"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.viewTabs.folders"
      })]
    })
  });
}
export default ViewFoldersTabV2;